// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"154":"17c5d51c","1814":"65c4da06","2026":"61b7b8ee","2285":"896978cb","3562":"4f034e44"}[chunkId] + ".css";
};